import { render } from "./inlist.vue?vue&type=template&id=079e76f2"
import script from "./inlist.vue?vue&type=script&lang=js"
export * from "./inlist.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__